import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  OnInit,
  OnDestroy,
  Component,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SnComponentUpdater } from '@lib/core';

import { SnTitleService } from '../../services/title.service';
import { SnTitleUpdateEvent } from '../../types/title-update-event.type';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[snTitle]',
  template: '{{ title }}',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'sn-title',
  },
})
export class SnTitleComponent implements OnInit, OnDestroy {
  public title: string;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _titleService: SnTitleService,
    private readonly _componentUpdater: SnComponentUpdater<SnTitleUpdateEvent>,
    private readonly _changeDetectorRef: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.title = this._titleService.getTitle();

    this._componentUpdater
      .componentUpdated$('sn-title')
      .pipe(takeUntil(this._destroy$))
      .subscribe((title) => {
        this.title = title;
        this._changeDetectorRef.markForCheck();
      });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
